module.exports = __webpack_public_path__ + "media/dice_roll.0d3cbec1.mp3";